import { Route, Routes } from 'react-router-dom-v5-compat'
import OrdersCurrent from './OrdersCurrent'
import OrdersFinished from './OrdersFinished'
import OrdersUntreated from './OrdersUntreated'
import { PickingProofsGallery } from './PickingProof/PickingProofsGallery'
import { OrderItemReplacement } from './OrderDetail/OrderItemList/OrderItemFulfillment/OrderItemReplacement'
import { OrderDetailProvider } from './OrderDetail/OrderDetailContext'
import OrderDetail from './OrderDetail'
import OrdersIndex from './index'
import { OrderScheduled } from './OrdersScheduled/OrderScheduled'
import DisputesList from '../Disputes/DisputesList'
import DisputeDetail from '../Disputes/DisputeDetail'
import { withFeatureGuard } from '../Shared/RouteGuards/FeatureRoute'

const OrderDetailWithProvider = () => (
  <OrderDetailProvider>
      <OrderDetail/>
  </OrderDetailProvider>
)

const ProtectedDisputesList = withFeatureGuard(DisputesList, 'disputes')
const ProtectedDisputeDetail = withFeatureGuard(DisputeDetail, 'disputes')

const OrdersRoutes = () => {
    return (
      <Routes>

          <Route path="orders">
              <Route element={<OrdersIndex/>}>
                  <Route index path="current" element={<OrdersCurrent/>}/>
                  <Route path="scheduled" element={<OrderScheduled/>}/>
                  <Route path="finished" element={<OrdersFinished/>}/>
                  <Route path="untreated" element={<OrdersUntreated/>}/>
                <Route path="dispute" element={<ProtectedDisputesList/>}/>
              </Route>

              <Route path=":id">
                  <Route index element={<OrderDetailWithProvider/>}/>
                  <Route path="picking-proofs" element={<PickingProofsGallery/>}/>
                  <Route path="items/:orderItemId/replacement" element={<OrderItemReplacement/>}/>
                  <Route path="dispute" element={<ProtectedDisputeDetail/>}/>
              </Route>
          </Route>
      </Routes>
    )
}

export { OrdersRoutes }
